/* eslint-disable import/prefer-default-export */
// for local UGC microservice testing use:
// https://localhost:44399/api/usergeneratedcontent
const baseURI = window.lp?.globals?.userGeneratedContentBaseUrl;

export { baseURI };
